import { render, staticRenderFns } from "./OrderAccountInfo.vue?vue&type=template&id=71dc73d4&"
import script from "./OrderAccountInfo.vue?vue&type=script&lang=js&"
export * from "./OrderAccountInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports